export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const SHOW_SNACKBAR = "Show Snackbar"
export const HIDE_SNACKBAR = "Hide Snackbar"